import React from 'react';

const ErrorMessage = ({ error, onRetry }) => {
  const getErrorInfo = (errorCode) => {
    switch (errorCode) {
      case 'API_KEY_MISSING':
        return {
          title: 'مطلوب مفتاح API',
          message: 'يرجى إضافة مفتاح GoldAPI.io الخاص بك في ملف .env كـ VITE_GOLD_API_KEY.',
          icon: '🔑',
          showRetry: false,
        };
      case 'API_KEY_INVALID':
        return {
          title: 'مفتاح API غير صالح',
          message: 'مفتاح API الخاص بك غير صالح. يرجى التحقق من مفتاح GoldAPI.io.',
          icon: '🚫',
          showRetry: false,
        };
      case 'RATE_LIMITED':
        return {
          title: 'تم تجاوز الحد المسموح',
          message: 'لقد تجاوزت الحد المسموح من الطلبات. يرجى الانتظار قليلاً والمحاولة مرة أخرى.',
          icon: '⏳',
          showRetry: true,
        };
      default:
        return {
          title: 'حدث خطأ ما',
          message: 'تعذر جلب أسعار الذهب. يرجى التحقق من الاتصال والمحاولة مرة أخرى.',
          icon: '⚠️',
          showRetry: true,
        };
    }
  };

  const { title, message, icon, showRetry } = getErrorInfo(error);

  return (
    <div className="error-container">
      <div className="error-card">
        <div className="error-icon">{icon}</div>
        <h3 className="error-title">{title}</h3>
        <p className="error-message">{message}</p>
        {showRetry && (
          <button className="error-retry-btn" onClick={onRetry} id="retry-button">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 8C2 4.69 4.69 2 8 2C10.22 2 12.16 3.21 13.2 5M14 8C14 11.31 11.31 14 8 14C5.78 14 3.84 12.79 2.8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              <path d="M13 2V5H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 14V11H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            إعادة المحاولة
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
